// import locations from "../../../shared/utility/locations.json";
// import { ParentStatus } from "../../../models/parent.model";

import MonthlyLeasePayments from "../component/MonthlyLeasePayment.component"
import "../styles/style.css"

export default function ReportPage() {

  return (<>

<div className='grid grid-cols-1 lg:grid-cols-1 gap-8 mb-8'>
  <MonthlyLeasePayments />
  <MonthlyLeasePayments />
					
				</div>
  
  </>)
}
